import { render, staticRenderFns } from "./editPayableStatement.vue?vue&type=template&id=10915f60&scoped=true&"
import script from "./editPayableStatement.vue?vue&type=script&lang=js&"
export * from "./editPayableStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10915f60",
  null
  
)

export default component.exports